import { render, staticRenderFns } from "./custom1948972425559461890.vue?vue&type=template&id=606465d7&scoped=true&"
import script from "./custom1948972425559461890.vue?vue&type=script&lang=js&"
export * from "./custom1948972425559461890.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606465d7",
  null
  
)

export default component.exports